import classnames from 'classnames';
import React from 'react';

type Props = {
    className?: string;
    number?: number;
    screenReaderText?: string;
};

const convertLargeNumbers = (number: number) => {
    if (number > 9) {
        return '9+';
    }
    return number > 0 ? number : '';
};

const NotificationBadge: React.FC<Props> = ({
    className = 'sgw-link-list__notification-badge',
    number,
    screenReaderText,
}) =>
    number ? (
        <>
            <span className="screen-reader-text">{screenReaderText}</span>
            <span className={classnames(className, { 'more-than-nine': number > 9 })}>
                {convertLargeNumbers(number)}
            </span>
        </>
    ) : null;

export default NotificationBadge;
